const dsShare = (($) => {

    const
        modal_share = 'div#white-modal[data-type="share"]',
        social_urls = {
            'twitter'  : 'https://twitter.com/doorsteporganic',
            'facebook' : 'https://www.facebook.com/DoorstepOrganics',
            'linkedin' : 'https://au.linkedin.com/company/doorstep-organics1',
            'email'    : '/contact-doorstep'
        },
        share_url = 'p#share-url',
        share_content = 'input#share-content';

    function getSocials() {
        return social_urls;
    }

    function shareOpen(heading = '', url = '', content = '') {
        $('h3#share-heading').html(heading);
        $('input#share-select').val(url);
        $('input#share-content').val(content)
        $(share_url).html(url);
        $(modal_share).css('display','flex');
    }

    function shareClose() {
        $(modal_share).css('display','none');
    }

    function shareCopyLink() {
        $('input#share-select').select();
        document.execCommand('copy');
    }

    function shareFacebook() {
        FB.ui({
            method: 'share',
            href: $(share_url).html(),
            quote: $(share_content).val()
        }, function(){});
    }

    function shareTwitter() {
        location.href = 'https://twitter.com/intent/tweet?text=' + $(share_content).val() + '&url=' + $(share_url).html() + '&via=doorsteporganic&hashtags=DoorstepOrganics';
    }

    $(document).ready(function () {
        $(modal_share).find('img.close-modal, button.grey').on('click', function() {
            shareClose();
        });

        $(modal_share).find('button.orange').on('click',function() {
            shareCopyLink();
        });

        $('a#share-facebook').on('click', function () {
            shareFacebook();
        });

        $('a.twitter-share-button').on('click', function () {
            shareTwitter();
        });

    });

    return {
        shareOpen  : shareOpen,
        getSocials : getSocials
    }

})(jQuery);